// Mock data for Vince Rodi portfolio website
// This file will be replaced/augmented with backend data later

export const ARTIST = {
  name: "Vince Rodi",
  tagline: "Pop / Variété Française",
  origin: "Sud de la France",
  email: "vince.rodimusic@gmail.com",
  label: "Vince Rodi",
  labelEmail: "vince.rodimusic@gmail.com",
  linktree: "https://linktr.ee/VinceRodi84?utm_source=linktree_profile_share&ltsid=musicien-variete",
  socials: [
    { name: "Instagram", url: "https://www.instagram.com/vincerodi84" },
    { name: "TikTok", url: "https://www.tiktok.com/@vincerodi84" },
    { name: "YouTube", url: "https://www.youtube.com/@vincerodi84" },
    { name: "Facebook", url: "https://www.facebook.com/vincerodi84" },
  ],
};

export const PHOTOS = {
  // Hero — portrait dramatique rouge/bleu (profil casquette)
  heroRedBlue: "https://customer-assets.emergentagent.com/job_17267f3a-915a-412b-97ff-a4b3bb5888d8/artifacts/2z16ueyu_f24e52d1-ecaf-44fe-803c-50d7f0807cec.jpeg",
  // Second portrait rouge/bleu (casquette tête baissée)
  stageRedBlue: "https://customer-assets.emergentagent.com/job_17267f3a-915a-412b-97ff-a4b3bb5888d8/artifacts/8717d85f_92fd11b3-97f1-4d90-bfa6-a3be428e035f.jpeg",
  // Portrait N&B sur canapé, bras croisés
  portraitSofa: "https://customer-assets.emergentagent.com/job_17267f3a-915a-412b-97ff-a4b3bb5888d8/artifacts/2d1dcw2x_2a5d4e3e-96f9-4392-8df0-1c41c279d035.jpeg",
  // Portrait N&B contemplatif (main sous le menton)
  portraitBW: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/op9k6i4m_0e1b220a-2557-4ff0-8d91-f50a79efb75b.jpeg",
  // Affiche officielle de la tournée 2026
  tour: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/utkj8g73_adb92ba5-20f8-42d4-9549-fd1a312bfde6.jpeg",
  // CDs physiques
  cdImage: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/p19d2j5b_9602E454-BE70-4BE4-9268-E88C5AA26F21.jpeg",
  // Pack / Bundle
  packImage: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/irkfpr6n_007abea8-f320-4f1f-b3bf-ccee1586c39e.jpeg",
};

export const EPK_PDF =
  "https://customer-assets.emergentagent.com/job_17267f3a-915a-412b-97ff-a4b3bb5888d8/artifacts/pa090yhr_Epk%20vince%20Rodi%202026.pdf";

export const BIO = {
  short: "Originaire d'un petit village du sud de la France, Vince Rodi a grandi bercé par la musique grâce à son père musicien. Auteur, compositeur et interprète, il signe une pop française sincère, à la croisée de la chanson, du rock et du blues.",
  long: [
    "Originaire d'un petit village du sud de la France, Vince Rodi, influencé dès l'enfance par son père musicien, a grandi dans une atmosphère musicale qui a forgé sa passion.",
    "Autodidacte et éclectique, il s'est d'abord intéressé à la chanson française avant de se tourner à l'adolescence vers la pop anglaise, le rock et le blues, qui façonnent aujourd'hui son univers.",
    "Pendant près de sept ans, il a partagé la scène avec son père et sa sœur, se produisant dans les bars de la région PACA. Son style unique mêle paroles sincères et mélodies pop entraînantes.",
    "Son univers musical, à la fois intime et universel, résonne avec une quête d'espoir et de reconstruction.",
  ],
};

export const EP = {
  title: "Et Après",
  type: "Premier EP — 6 titres",
  description:
    "À travers ces six chansons, l'EP offre une réflexion profonde sur les épreuves personnelles, les désirs, et la manière dont nous faisons face aux défis émotionnels. Chaque morceau souligne l'importance de se reconstruire, d'accepter la vulnérabilité et de trouver un sens dans nos relations — qu'elles soient familiales, amoureuses ou personnelles. Un voyage de réconciliation avec soi-même et avec les autres, porteur de résilience et de renouveau.",
  tracks: [
    {
      n: "01",
      title: "Voilà Pourquoi",
      tag: "Single",
      text: "Single de l'EP. Une déclaration d'amour, malgré la peur du lâcher prise et de devoir accorder à nouveau sa confiance — comme une thérapie qui décrit la reconstruction après une blessure émotionnelle profonde.",
    },
    {
      n: "02",
      title: "Ça Le Fait",
      tag: "",
      text: "Désirs et passions de l'acte d'amour charnel, où rêve et fantasme se fondent dans une harmonie fragile entre attirance et fuite.",
    },
    {
      n: "03",
      title: "À Tort ou À Raison",
      tag: "",
      text: "Une réflexion sur les conflits intérieurs, l'incompréhension et les émotions qui surgissent dans un tourbillon de silence et de frustrations.",
    },
    {
      n: "04",
      title: "Le Pont",
      tag: "",
      text: "Les tourments intérieurs d'une personne à un moment clé : la quête de sens, les attentes sociales et familiales, et la possibilité de prendre un autre chemin.",
    },
    {
      n: "05",
      title: "Ma Famille",
      tag: "",
      text: "Un hymne à la résilience et à l'importance des liens familiaux, même lorsque tout semble s'effondrer autour de soi.",
    },
    {
      n: "06",
      title: "Stand By Me",
      tag: "Cover",
      text: "Une réinterprétation en français du morceau intemporel — une présence réconfortante qui permet de tenir debout dans les moments de doute.",
    },
  ],
};

export const TOUR_DATES = [
  { id: 1, date: "2026-06-04", day: "04", month: "JUIN", city: "Strasbourg", venue: "À confirmer", region: "Grand Est" },
  { id: 2, date: "2026-06-04", day: "04", month: "JUIN", city: "Mulhouse", venue: "À confirmer", region: "Grand Est" },
  { id: 3, date: "2026-06-06", day: "06", month: "JUIN", city: "Lyon", venue: "À confirmer", region: "Auvergne-Rhône-Alpes" },
  { id: 4, date: "2026-06-09", day: "09", month: "JUIN", city: "Aix-en-Provence", venue: "À confirmer", region: "PACA" },
  { id: 5, date: "2026-06-10", day: "10", month: "JUIN", city: "Marseille", venue: "À confirmer", region: "PACA" },
  { id: 6, date: "2026-06-12", day: "12", month: "JUIN", city: "Nice", venue: "À confirmer", region: "PACA" },
  { id: 7, date: "2026-06-13", day: "13", month: "JUIN", city: "Montpellier", venue: "À confirmer", region: "Occitanie" },
  { id: 8, date: "2026-06-19", day: "19", month: "JUIN", city: "Lille", venue: "À confirmer", region: "Hauts-de-France" },
  { id: 9, date: "2026-06-20", day: "20", month: "JUIN", city: "Épinay-sur-Seine", venue: "À confirmer", region: "Île-de-France" },
  { id: 10, date: "2026-06-21", day: "21", month: "JUIN", city: "Paris", venue: "Fête de la Musique", region: "Île-de-France", highlight: true },
];

export const MERCH = [
  {
    id: "cd-et-apres",
    name: "CD — EP « Et Après »",
    price: 5,
    category: "Musique",
    image: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/2sxqimgn_95d156c7-51f8-42e2-baed-58e0855e7203.jpeg",
    description: "Le premier EP de Vince Rodi en CD physique, 6 titres incluant le single 'Voilà Pourquoi' et la cover 'Stand By Me'.",
  },
  {
    id: "bundle-fan",
    name: "Bundle Pack",
    price: 10,
    category: "Bundle",
    image: "https://customer-assets.emergentagent.com/job_musicien-variete/artifacts/xgithrxn_35af84fe-bfb8-4518-b6bf-a51dcbabefc2.JPG",
    description: "Le pack complet : CD + Clé USB + Poster + Photo + Stickers. Édition limitée — uniquement disponible en bundle, tarif préférentiel.",
  },
];

export const NAV_CATEGORIES = [
  { key: "presentation", label: "Présentation", subtitle: "L'artiste", to: "/presentation", external: false },
  { key: "ep", label: "Mon Nouvel EP", subtitle: "Et Après — écouter", to: "https://linktr.ee/VinceRodi84?utm_source=linktree_profile_share&ltsid=musicien-variete", external: true },
  { key: "tournee", label: "Toutes les dates", subtitle: "10 dates · 9 villes", to: "/tournee", external: false, expandable: true },
  { key: "merch", label: "Merchandising", subtitle: "CD · Bundle Pack", to: "/merch", external: false },
  { key: "prestations", label: "Événementiel", subtitle: "Formules · Photos & vidéos de concert", to: "/prestations", external: false },
  { key: "contact", label: "Contact", subtitle: "Booking & presse", to: "/contact", external: false },
];

// Galeries placeholder — à remplacer par les vrais médias envoyés par l'artiste.
export const PRESTATIONS_PHOTOS = [
  { id: "p0", caption: "Concert de septembre 2026 au Montparnasse à Hellemmes", image: "https://customer-assets-4nw71qhi.emergentagent.net/job_musicien-variete/artifacts/2vw6rhl6_EDBEAAC3-9BBB-4331-8474-88D073E47173.webp" },
  { id: "p2", caption: "Vince Rodi — Portrait", image: "https://customer-assets-4nw71qhi.emergentagent.net/job_musicien-variete/artifacts/hencwy54_IMG_1908.webp" },
  { id: "p1", caption: "Flyer prestation événementielle", image: "https://customer-assets-4nw71qhi.emergentagent.net/job_musicien-variete/artifacts/pirdys1z_Design%20sans%20titre.png" },
  { id: "p3", caption: "Scène — Soir d'été", image: PHOTOS.stageRedBlue },
  { id: "p4", caption: "Backstage — Avant l'entrée scène", image: PHOTOS.portraitBW },
  { id: "p5", caption: "Live — Lumière rouge", image: PHOTOS.heroRedBlue },
  { id: "p6", caption: "Set acoustique", image: PHOTOS.portraitSofa },
  { id: "p7", caption: "Tournée 2026 — Affiche", image: PHOTOS.tour },
  { id: "p8", caption: "Showcase intimiste", image: PHOTOS.cdImage },
];

export const PRESTATIONS_VIDEOS = [
  {
    id: "v0",
    title: "Vince Rodi — Ça le fait",
    description: "Vidéo vitrine : l'univers de Vince Rodi en un extrait — voix, énergie, présence.",
    poster: "/videos/vitrine-ca-le-fait-poster.jpg",
    src: "/videos/vitrine-ca-le-fait.mp4",
    type: "video/mp4",
    featured: true,
    portrait: true,
  },
  {
    id: "v1",
    title: "Concert · Les Baratineurs",
    description: "Vince Rodi en live sur la scène des Baratineurs — captation intégrale.",
    poster: PHOTOS.stageRedBlue,
    src: "/videos/concert-baratineurs.mp4",
    type: "video/mp4",
  },
  {
    id: "v2",
    title: "Live — Ambiance de scène",
    description: "Immersion visuelle sur scène, jeu de lumières et présence live.",
    poster: PHOTOS.portraitBW,
    src: "/videos/live-scene.mp4",
    type: "video/mp4",
  },
  {
    id: "v3",
    title: "Session live — Extrait concert",
    description: "Extrait d'un concert récent : voix, guitare et énergie brute.",
    poster: PHOTOS.heroRedBlue,
    src: "/videos/live-session.mp4",
    type: "video/mp4",
  },
  {
    id: "v4",
    title: "Concert · Le Montparnasse — Hellemmes",
    description: "Concert du mois de septembre au Montparnasse à Hellemmes.",
    poster: PHOTOS.stageRedBlue,
    src: "https://customer-assets-4nw71qhi.emergentagent.net/job_musicien-variete/artifacts/p1epvjzm_33d9a7cf-b372-427d-a5dd-7258c84a61cc.mp4",
    type: "video/mp4",
  },
  {
    id: "v5",
    title: "Concert · Ozest — Morez",
    description: "Concert d'octobre 2026 au Ozest à Morez.",
    poster: "/videos/ozest-morez-1-poster.jpg",
    src: "/videos/ozest-morez-1.mp4",
    type: "video/mp4",
  },
  {
    id: "v6",
    title: "Concert · Ozest — Morez",
    description: "Concert d'octobre 2026 au Ozest à Morez.",
    poster: "/videos/ozest-morez-2-poster.jpg",
    src: "/videos/ozest-morez-2.mp4",
    type: "video/mp4",
  },
];
